import {api} from '../../utils/api'

export default {

    /**
     * get all intervals
     * @param commit
     * @param node_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadIntervals({commit}, node_id) {
        return api.call(commit, 'get', '/api/roadmap/interval/'+node_id, null, 'SET_INTERVALS');
    },

    /**
     * Add new intervals
     * @param commit
     * @param node_id
     * @param from
     * @param to
     * @param payload
     * @returns {Promise<any>}
     */
    addInterval({ commit }, {node_id, from, to}) {

        // Call register
        return api.call(commit, 'post', `/api/roadmap/interval/${node_id}`, {from, to}, 'SET_INTERVALS');
    },

    /**
     * Update interval
     * @param commit
     * @param interval_id
     * @param payload
     * @returns {Promise<any>}
     */
    updateInterval({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', `/api/roadmap/interval/${payload.id}`, payload, 'SET_INTERVALS');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param interval_id
     * @param payload
     * @returns {Promise<any>}
     */
    removeInterval({ commit }, interval_id) {

        // Call register
        return api.call(commit, 'delete', `/api/roadmap/interval/${interval_id}`, false, 'DELETE_INTERVALS');
    },

    /**
     * get all departments
     * @param commit
     * @param node_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadDepartments({commit}, node_id) {
        return api.call(commit, 'get', '/api/roadmap/department/'+node_id, null, 'SET_DEPARTMENTS');
    },

    /**
     * Add new departments
     * @param commit
     * @param node_id
     * @param from
     * @param to
     * @param payload
     * @returns {Promise<any>}
     */
    addDepartment({ commit }, {node_id, title}) {

        // Call register
        return api.call(commit, 'post', `/api/roadmap/department/${node_id}`, {title}, 'SET_DEPARTMENTS');
    },

    /**
     * Update department
     * @param commit
     * @param department_id
     * @param payload
     * @returns {Promise<any>}
     */
    updateDepartment({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', `/api/roadmap/department/${payload.id}`, payload, 'SET_DEPARTMENTS');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param department_id
     * @param payload
     * @returns {Promise<any>}
     */
    removeDepartment({ commit }, department_id) {

        // Call register
        return api.call(commit, 'delete', `/api/roadmap/department/${department_id}`, false, 'DELETE_DEPARTMENTS');
    },

    /**
     * get all goals
     * @param commit
     * @param node_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadGoals({commit}, node_id) {
        return api.call(commit, 'get', '/api/roadmap/goal/'+node_id, null, 'SET_GOALS');
    },

    /**
     * load goal info
     * @param commit
     * @param id
     * @returns {*|Promise|Promise<any>}
     */
    loadGoalInfo({commit}, id) {
        return api.call(commit, 'get', `/api/roadmap/goal/info/${id}`);
    },

    /**
     * Add new goals
     * @param commit
     * @param node_id
     * @param from
     * @param to
     * @param payload
     * @returns {Promise<any>}
     */
    addGoal({ commit }, {interval_id, department_id, title}) {

        // Call register
        return api.call(commit, 'post', `/api/roadmap/goal/${interval_id}/${department_id}`, {title}, 'SET_GOALS');
    },

    /**
     * Update goal
     * @param commit
     * @param goal_id
     * @param payload
     * @returns {Promise<any>}
     */
    updateGoal({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', `/api/roadmap/goal/${payload.id}`, payload, 'SET_GOALS');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param goal_id
     * @param payload
     * @returns {Promise<any>}
     */
    removeGoal({ commit }, goal_id) {

        // Call register
        return api.call(commit, 'delete', `/api/roadmap/goal/${goal_id}`, false, 'DELETE_GOALS');
    },


    /**
     * get all budgets
     * @param commit
     * @param node_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadBudgets({commit}, node_id) {
        return api.call(commit, 'get', '/api/roadmap/budget/'+node_id, null, 'SET_BUDGETS');
    },

    /**
     * Add new budgets
     * @param commit
     * @param node_id
     * @param from
     * @param to
     * @param payload
     * @returns {Promise<any>}
     */
    addBudget({ commit }, {interval_id, department_id, budget}) {

        // Call register
        return api.call(commit, 'post', `/api/roadmap/budget/${interval_id}/${department_id}`, {budget}, 'SET_BUDGETS');
    },

    /**
     * Update budget
     * @param commit
     * @param budget_id
     * @param payload
     * @returns {Promise<any>}
     */
    updateBudget({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', `/api/roadmap/budget/${payload.id}`, payload, 'SET_BUDGETS');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param budget_id
     * @param payload
     * @returns {Promise<any>}
     */
    removeBudget({ commit }, budget_id) {

        // Call register
        return api.call(commit, 'delete', `/api/roadmap/budget/${budget_id}`, false, 'DELETE_BUDGETS');
    },


    /**
     * get all incomes
     * @param commit
     * @param node_id
     * @param task_id
     * @returns {*|Promise|Promise<any>}
     */
    loadIncomes({commit}, node_id) {
        return api.call(commit, 'get', '/api/roadmap/income/'+node_id, null, 'SET_INCOMES');
    },

    /**
     * Add new incomes
     * @param commit
     * @param node_id
     * @param from
     * @param to
     * @param payload
     * @returns {Promise<any>}
     */
    addIncome({ commit }, {interval_id, income}) {

        // Call register
        return api.call(commit, 'post', `/api/roadmap/income/${interval_id}`, {income}, 'SET_INCOMES');
    },

    /**
     * Update income
     * @param commit
     * @param income_id
     * @param payload
     * @returns {Promise<any>}
     */
    updateIncome({ commit }, payload) {

        // Call register
        return api.call(commit, 'patch', `/api/roadmap/income/${payload.id}`, payload, 'SET_INCOMES');
    },

    /**
     * Remove tasktag
     * @param commit
     * @param income_id
     * @param payload
     * @returns {Promise<any>}
     */
    removeIncome({ commit }, income_id) {

        // Call register
        return api.call(commit, 'delete', `/api/roadmap/income/${income_id}`, false, 'DELETE_INCOMES');
    },
}
